import React, { useState } from "react";
import { Formik, Field } from "formik";
import * as yup from "yup";
import CMSFormSelect from "../../formFields/CMSFormSelect";
import CMSFormTextArea from "../../formFields/CMSFormTextArea";
import Icon from "../../common/Icon";
import ContainerLoading from "../../common/loading/ContainerLoading";
import { useToast } from "../../contexts/ToastContext";
import { cancelSchema } from "../../utils/validations";

const CancelOrderForm = ({ order, onSubmit }) => {
  const [status, setStatus] = useState("idle"); // idle | loading | success
  const { addToast } = useToast();
  const reasons = [
    { label: "Wrong item ordered", value: "Wrong item ordered" },
    { label: "Change of mind", value: "Change of mind" },
    { label: "Delivery taking too long", value: "Delivery taking too long" },
    { label: "Other", value: "Other" },
  ];

  return (
    <div className="mx-auto mt-8 p-6 lg:px-10 bg-[#F5F5F5] rounded-xl shadow-md relative">
      <h2 className="text-28pt  mb-6">Cancel Order</h2>

      {status === "loading" && (
        <div className="absolute inset-0 flex items-center justify-center rounded-[15px] z-10">
          <ContainerLoading />
        </div>
      )}
      {/* Order Summary */}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
        <h3 className="text-24pt border-b border-b-gray pb-2 mb-2">
          Order Summary{" "}
          {/* <span
            className={`px-2 py-1 rounded-full text-10pt   bg-green text-white`}
          >
            {order?.status}
          </span> */}
        </h3>
        <p>
          <span className="font-medium">Order ID:</span> {order.id}{" "}
        </p>
        <div className="flex flex-col gap-2 my-2 py-2">
          {order.products.map((p, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <img
                src={p.image}
                alt={p.name}
                className="w-14 h-14 object-cover rounded"
              />
              <p>{p.name}</p>
            </div>
          ))}
        </div>
        <p className=" border-t border-t-gray mt-2 pt-2 text-right">
          <span className="font-medium">Total Amount:</span>{" "}
          <span className="font-sans text-18pt text-green mt-2 ">
            {" "}
            {order?.totalAmount} AED
          </span>
        </p>
      </div>

      {/* Cancel Form */}
      <Formik
        initialValues={{
          reason: "",
          customReason: "",
          confirm: false,
        }}
        validationSchema={cancelSchema}
        onSubmit={async (values, { resetForm }) => {
          setStatus("loading");
          try {
            // Simulate API call
            await new Promise((resolve) => setTimeout(resolve, 1500));
            setStatus("success");
      
            if (onSubmit) onSubmit(values);
            addToast("Cancellation request submitted", "success");

            // Reset form after 3s
            setTimeout(() => {
              resetForm();
              setStatus("idle");
            }, 100);
          } catch (err) {
            setStatus("idle");
            alert("Submission failed. Please try again.");
          }
        }}
      >
        {(form) => (
          <form className="flex flex-col gap-6" onSubmit={form.handleSubmit}>
            {/* Reason selection */}
            <div>
              <CMSFormSelect
                name="reason"
                label="Reason for Cancellation"
                selected={form.values.reason}
                className="1"
                placeholder={{ label: "Reason", value: "" }}
                form={form}
                onChange={form.handleChange}
                required
                options={reasons}
              />
            </div>

            {/* Optional custom text */}
            {form.values.reason === "Other" && (
              <div>
                <CMSFormTextArea
                  name="customReason"
                  label="Reason"
                  maxLength={300}
                  form={form}
                  required
                />
              </div>
            )}

            {/* Confirmation checkbox */}
            <div
              className="flex items-center justify-start mt-2 cursor-pointer relative"
              onClick={() =>
                form.setFieldValue(
                  "confirm",
                  form.values.confirm === "1" ? "0" : "1"
                )
              }
            >
              <div className="w-[25px] h-[26px] ms-1 me-2">
                <Icon
                  icon={form.values.confirm === "1" ? "checked" : "checkbox"}
                  className={
                    form.values.confirm === "1"
                      ? "w-[25px] h-auto"
                      : "w-[25px] h-auto"
                  }
                />
              </div>

              <p className="text-green text-18pt md:text-21pt select-none ">
                I understand this order will be cancelled
              </p>
              {form.errors.confirm && form.touched.confirm && (
                <p className="errorMessage">{form.errors.confirm}</p>
              )}
            </div>

            {/* Cancellation Policy Notice */}
            <p className="text-xs text-gray-500 mt-0 ms-2">
              By cancelling this order, you agree to our cancellation policy.
            </p>

            {/* Action Button */}
            <div className="flex justify-end mt-0">
              <button
                type="submit"
                disabled={status === "loading" || status === "success"}
                className={`generalButton flex items-center gap-1 px-2 text-20pt  rounded-md font-mono transition whitespace-nowrap text-white ${
                  status === "loading"
                    ? "bg-gray cursor-not-allowed"
                    : status === "success"
                    ? "bg-green cursor-not-allowed"
                    : "bg-secondary"
                }`}
              >
                {status === "loading"
                  ? "Submitting..."
                  : status === "success"
                  ? "Cancelled!"
                  : "Submit Cancellation"}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default CancelOrderForm;
